<template>
    <MenuBase :hidden="props.hidden" 
        :tooltipPosition="props.tooltipPosition" 
        :theme="props.theme" 
        :tooltipText="props.tooltipText"
        @click="toggleTuner()">
        <TuningForkIcon class="size-6 text-emerald-500 hover:text-emerald-400 transition-colors" />
    </MenuBase>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
import MenuBase from '@/components/common/menus/MenuBase.vue';
import TuningForkIcon from '@/components/icons/TuningForkIcon.vue';
import { appEvents } from '@/store/app.events';

const emit = defineEmits(['toggleTuner']);
const props = defineProps({
    disabled: {
        type: Boolean,
        default: false
    },
    hidden: {
        type: Boolean,
        default: false
    },
    tooltipPosition: {
        type: String,
        default: 'top'
    },
    theme: {
        type: String,
        default: 'light'
    },
    tooltipText: {
        type: String,
        default: 'Afinador'
    }
});

const toggleTuner = () => {
    emit('toggleTuner');
    appEvents.emit('toggleTuner');
};
</script>
